import React from "react";
import {useLocation} from "react-router-dom"
import logo from "../../logo.svg";
//styling
import "./sidebar.scss";

const SideBar = ({ children }) => {
  let pathname = useLocation().pathname.toLowerCase()
  const isExam=pathname.includes("exam")
  return (
    <div className="sidebar-container bg-primary position-absolute position-fixed py-4 px-4">
      <div className="vh-100">
        <div className={`logo-container ${isExam?"ps-5":""}`}>
          <img src={logo} alt="proctorMe logo" />
        </div>
        {children}
      </div>
    </div>
  );
};

export default SideBar;
